import { IValueLabelGeneric } from "@mctypes/global.types";
import { Button, Group, Modal, TextInput } from "@mantine/core";
import React from "react";
import { DropdownSelectorDeprecated } from "../../../components";
import { BatchJobTemplateEnum } from "./batchJobConstants";

const NewBatchJobModal: React.FC<{
  onCreate: (name: string, template: BatchJobTemplateEnum) => void;
  closeModal: () => void;
  templates: IValueLabelGeneric<string>[];
}> = ({ onCreate, closeModal, templates }) => {
  const [name, setName] = React.useState<string>("");
  const [template, setTemplate] = React.useState<BatchJobTemplateEnum>(null);

  return (
    <Modal opened onClose={closeModal} title="Ny BatchJob">
      <div>
        <div className="w-100">
          <div className="d-flex align-items-center mb-2">
            <div style={{ width: "20%" }}>Navn</div>
            <div style={{ width: "80%" }}>
              <TextInput placeholder="Angi navn på batch-jobb" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <div className="d-flex align-items-center mb-2">
            <div style={{ width: "20%" }}>Mal</div>
            <div style={{ width: "80%" }}>
              <DropdownSelectorDeprecated
                items={templates}
                displayKey="label"
                fullWidth
                setItem={(_template) => setTemplate(_template.value)}
                activeItem={templates.find((temp) => temp.value === template)}
                selectText={template != null ? template : "Velg batch-jobb-mal"}
                color="mc-blue"
              />
            </div>
          </div>
        </div>
      </div>
      <Group justify="flex-end" mt="md">
        <Button disabled={name === "" || template == null} color="green" onClick={() => onCreate(name, template)}>
          Opprett
        </Button>
        <Button variant="default" onClick={closeModal}>
          Avbryt
        </Button>
      </Group>
    </Modal>
  );
};

export default NewBatchJobModal;
